<div *ngIf="data">
    <div class="user-entry" *ngFor="let u of data.user">
        <app-admin-user-list-item
            [user]="u"
            (update)="saveUser($event, u)"
            [busy]="busy"
        ></app-admin-user-list-item>
    </div>
</div>
